import { createIcon } from '../icons/utils';

/**
 * Legacy ProgressBars' SMS glyph: a speech bubble inside a filled ring
 * (`msg-circle.svg`). Its viewBox is 25x26 — legacy drew this ring one unit taller
 * than the call one, and keeping that is what makes the two line up as legacy had
 * them rather than at subtly different sizes.
 *
 * Same fixed teal as {@link CallCircleIcon}: `--primary-600` on `--primary-100`,
 * which is legacy's `#009999` / `#D9F0F0` exactly.
 */
export const MessageCircleIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.5 24.5C18.8513 24.5 24 19.3513 24 13C24 6.64873 18.8513 1.5 12.5 1.5C6.14873 1.5 1 6.64873 1 13C1 19.3513 6.14873 24.5 12.5 24.5Z"
        fill="hsl(var(--primary-100))"
        stroke="hsl(var(--primary-600))"
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2873 18.1159H9.97119C7.44255 18.1159 6.17822 17.4837 6.17822 14.3229V11.1621C6.17822 8.63346 7.44255 7.36914 9.97119 7.36914H15.0285C17.5571 7.36914 18.8215 8.63346 18.8215 11.1621V14.3229C18.8215 16.8516 17.5571 18.1159 15.0285 18.1159H14.7124C14.5164 18.1159 14.3268 18.2107 14.2067 18.3687L13.2584 19.6331C12.8412 20.1894 12.1585 20.1894 11.7412 19.6331L10.793 18.3687C10.6919 18.2297 10.458 18.1159 10.2873 18.1159Z"
        stroke="hsl(var(--primary-600))"
        strokeWidth={0.948242}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* The three dots inside the bubble. */}
      <path
        d="M15.0265 13.0588H15.0322M12.4972 13.0588H12.5029M9.96788 13.0588H9.97356"
        stroke="hsl(var(--primary-600))"
        strokeWidth={1.26432}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'MessageCircleIcon', defaultSize: 25, classNameBase: '' },
);
